
      import Success from './success.vue'
      import type { App, Plugin } from 'vue'

      export const SuccessPlugin: Plugin = {
        install(app: App) {
          app.component('Success', Success)
        },
      }
      export { Success }
      